import React from 'react'
import MySelect from '../formGroup/MySelect'
import {
  autreDifferentTaxCountryRaison,
  differentTaxCountryRaison,
} from './Options'
import { IStep5WithUploadProps } from '../../interfaces/Step5'
import TextInput from '../formGroup/TextInput'
import StepUploadWithValidateButton from '../upload/StepUploadWithValidateButton'
import { useTriggerChangeHook } from '../../hooks/triggerChangeHook'
import { getItemSuffix } from '../../utils/getItemSuffix'

function ReasonDifferentDomicile({
  form,
  folderData,
  step,
  stepUploadFileProps,
  item,
  addState,
  removeState,
}: IStep5WithUploadProps) {
  const { errors, register, triggerValidation, watch } = form
  const typeRaisonDomicileDifferentSuffix = `type_fr_raison_domicile_different${getItemSuffix(
    item
  )}`
  const autreFrRaisonDomicileDifferentSuffix = `autre_fr_raison_domicile_different${getItemSuffix(
    item
  )}`

  const type_fr_raison_domicile_different =
    folderData[typeRaisonDomicileDifferentSuffix]
  const autre_fr_raison_domicile_different =
    folderData[autreFrRaisonDomicileDifferentSuffix]
  const watchTypeFrRaisonDomicileDifferent: string = watch(
    typeRaisonDomicileDifferentSuffix,
    type_fr_raison_domicile_different
  )
  const isAutreSelected =
    watchTypeFrRaisonDomicileDifferent === autreDifferentTaxCountryRaison

  useTriggerChangeHook(typeRaisonDomicileDifferentSuffix)

  return (
    <div className="row">
      <div className="col12">
        <MySelect
          options={differentTaxCountryRaison}
          value={type_fr_raison_domicile_different || ''}
          register={register({ required: true })}
          name={typeRaisonDomicileDifferentSuffix}
          id={typeRaisonDomicileDifferentSuffix}
          error={errors[typeRaisonDomicileDifferentSuffix]}
          label="Raison"
          onChange={(event) => {
            // 6 = Autre option
            if (event.target.value === '6') {
              removeState?.(item ? 2 : 1)
            } else {
              addState?.(item ? 2 : 1)
            }
          }}
          required
        />
        {watchTypeFrRaisonDomicileDifferent && (
          <>
            {isAutreSelected ? (
              <TextInput
                register={register({ required: true, maxLength: 40 })}
                error={errors[autreFrRaisonDomicileDifferentSuffix]}
                name={autreFrRaisonDomicileDifferentSuffix}
                id={autreFrRaisonDomicileDifferentSuffix}
                defaultValue={autre_fr_raison_domicile_different || ''}
                label="Préciser"
                required
                inputClassName="inputField inputFieldSecondary"
                className="mt2 mt6lg"
                placeHolder="Votre texte ici..."
                triggerValidation={triggerValidation}
                maxLength={40}
              />
            ) : (
              <div className="mt2 mt6lg">
                <StepUploadWithValidateButton
                  {...{
                    ...stepUploadFileProps,
                    index: item ? 2 : 1,
                    title: 'Joindre un document justifiant de votre situation',
                    step,
                  }}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default ReasonDifferentDomicile
